<app-menubar [headerUntranslated]="job ? (jobClass.getJobDisplayName(job) ?? ('Job.unnamed' | translate)) : ''" [hideTitleOniOS]="true" [showBackButton]="true">
    <div class="optionsMenu">
        <button [matMenuTriggerFor]="optionsMenu" class="iconButton" color="primary" mat-stroked-button>
            <fa-icon [icon]="(exportingPdf || exportingCsv ? appIcons.loading : appIcons.extraMenu)" [animation]="(exportingPdf ? 'spin' : undefined)" class="align-right"></fa-icon>
        </button>
        <mat-menu #optionsMenu>
            <mat-action-list>
                <button (click)="exportJob()" class="iconButton" mat-list-item>
                    <fa-icon [icon]="appIcons.fileOut" matListItemIcon></fa-icon>
                    <span matListItemTitle>{{'JobDesigner.export' | translate}}</span>
                </button>

                <button (click)="exportCsv()" class="iconButton menuItem" mat-list-item>
                    <fa-icon [icon]="appIcons.csvIcon" matListItemIcon></fa-icon>
                    <span matListItemTitle>{{'CsvExport.export' | translate}}</span>
                </button>

                <button (click)="exportPdf()" class="iconButton menuItem" mat-list-item>
                    <fa-icon [icon]="appIcons.pdfIcon" matListItemIcon></fa-icon>
                    <span matListItemTitle>{{'PdfExport.export' | translate}}</span>
                </button>
            </mat-action-list>
        </mat-menu>
    </div>

</app-menubar>

<ion-content [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large">{{job ? (jobClass.getJobDisplayName(job) ?? ('Job.unnamed' | translate)) : ''}}</ion-title>
        </ion-toolbar>
    </ion-header>

    <div *ngIf="job" class="content">
        <app-property-list
            (propertiesUpdatedEvent)="updateProperties($event)"
            [highlightFirstProperties]="3"
            [allowNewProperties]="true"
            [properties]="job.properties">
        </app-property-list>

        <div *ngIf="job.parts" class="partsContainer">
            <button (click)="previousPart()" [disabled]="!canSelectPreviousPart" class="navigationButton" mat-fab>
                <fa-icon [icon]="appIcons.previousMarkerIcon"></fa-icon>
            </button>

            <swiper-container #swiperContainer pagination="true" effect="coverflow" grab-cursor="true" centered-slides="true"
                              slides-per-view="auto" coverflow-effect-rotate="50" coverflow-effect-stretch="0" coverflow-effect-depth="100"
                              coverflow-effect-modifier="1" coverflow-effect-slide-shadows="true">
                <swiper-slide *ngFor="let part of job.parts; let index = index" class="slide">
                    <app-part-editor (markerSelectedEvent)="markerChanged($event)" [caption]="getPartCaption(part)" [disabled]="false" [part]="part" mode="markerSelection"></app-part-editor>
                </swiper-slide>
            </swiper-container>

            <button (click)="nextPart()" [disabled]="!canSelectNextPart" class="navigationButton" mat-fab>
                <fa-icon [icon]="appIcons.nextMarkerIcon"></fa-icon>
            </button>
        </div>

        <div class="photos">
            <app-photo-list (newPhotoEvent)="onNewPhoto($event)" (removePhotoEvent)="onRemovePhoto($event)" (addGraphs)="addCharts()" [photos]="currentPhotos" [chartsCount]="chartsCount"></app-photo-list>
        </div>

        <div class="measurementsList">
            <app-measurement-table #measurementTable
                                   (deleteMeasurement)="deleteMeasurement($event)"
                                   (dirtyState)="this.save()"
                                   (chartAdded)="chartAdded($event)"
                                   [measurements]="currentMeasurements"
                                   [allowSaveChart]="true"
            >
            </app-measurement-table>
        </div>

        <button
            (click)="delete()"
            *ngIf="job.id"
            class="bigButton"
            color="warn"
            mat-flat-button>
            {{'Generic.delete' | translate}}
        </button>
    </div>
</ion-content>
